import { ChecklistAnswerSpec, ChecklistQuestionSpec, QuestionType } from "@nova/schemas"
import { useCallback, useMemo, useState } from "react"
import { canSubmitAnswers, createEmptyAnswers } from "./answers"

export * from "./answers"
export * from "./format-aircraft-label"
export * from "./linking-form"

export const useChecklistFormControls = (form: ChecklistQuestionSpec[]) => {
    const [answers, setAnswers] = useState(() => createEmptyAnswers(form))

    const canSubmit = useMemo(() => canSubmitAnswers({ form, answers }), [answers, form])

    const updateAnswer = useCallback(
        <T extends QuestionType>(id: string, answerSpec: ChecklistAnswerSpec<T>) => {
            setAnswers((prev) => ({ ...prev, [id]: answerSpec }))
        },
        []
    )

    const answerControls = useMemo(() => ({ updateAnswer }), [updateAnswer])

    const clearForm = useCallback(() => setAnswers(createEmptyAnswers(form)), [form])

    return { answers, canSubmit, updateAnswer, answerControls, clearForm }
}
